import { Token } from '@core/models/auth.models';
import heic2any from 'heic2any';

export function base64ToFormData(base64String: string): File {
  const mimeType = base64String.match(/data:(.*?);base64,/)![1];

  const mimeToExt: { [key: string]: string } = {
    'image/png': 'png',
    'image/jpeg': 'jpg',
    'image/jpg': 'jpg',
  };

  const fileExtension = mimeToExt[mimeType] || mimeType.split('/')[1];

  const fileName = `profileImage.${fileExtension}`;

  const byteString = atob(base64String.split(',')[1]);

  const arrayBuffer = new ArrayBuffer(byteString.length);

  const uint8Array = new Uint8Array(arrayBuffer);

  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i);
  }

  const blob = new Blob([uint8Array], { type: mimeType });

  const file = new File([blob], fileName, { type: mimeType });

  return file;
}

export const parseJwt = (token: string): Token | null => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Invalid token', error);
    return null;
  }
};

export async function convertHeicToJpeg(file: File): Promise<Blob> {
  return (await heic2any({
    blob: file,
    toType: 'image/jpeg',
    quality: 0.75,
  })) as Blob;
}
